import React from "react";
import { MessageSquare } from "lucide-react";
import { SVGIconProps } from "@/interface/icon.types";

const filterId = "filter0_i_blue_message";
const gradientId = "paint0_linear_blue_message";

const BlueMessageIcon = ({ className }: SVGIconProps) => {
  return (
    <svg
      className={className}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter={`url(#${filterId})`}>
        <rect width="36" height="36" rx="8" fill="#5ACDFF" />
        <rect
          width="36"
          height="36"
          rx="8"
          fill="white"
          fillOpacity="0.1"
        />
        <rect
          x="0.5"
          y="0.5"
          width="35"
          height="35"
          rx="7.5"
          stroke={`url(#${gradientId})`}
          strokeOpacity="0.5"
        />
        <foreignObject x="6" y="6" width="24" height="24">
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              color: "white",
            }}
          >
            <MessageSquare size={20} strokeWidth={2} />
          </span>
        </foreignObject>
      </g>
      <defs>
        <filter
          id={filterId}
          x="0"
          y="-4"
          width="36"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.64 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_blue_message"
          />
        </filter>
        <linearGradient
          id={gradientId}
          x1="18"
          y1="0"
          x2="18"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008BCA" />
          <stop offset="1" stopColor="#5ACDFF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BlueMessageIcon;
